export default "__VITE_ASSET__Dl$UcFk2__"